export default __webpack_public_path__ + "static/media/pilz-15.0de0db67.png";